import React from 'react';
import Accordion from '../../Accordion';
import AccordionItem from '../../Accordion/AccordionItem';
import { FilterHdrOutlined, HdOutlined, HomeWorkOutlined, FenceOutlined, AddRoadOutlined, PanoramaPhotosphereOutlined } from '@mui/icons-material';

const TDLAYERS = [
  {
    icon: <FenceOutlined />,
    label: 'Boundaries',
    id: 0,
    visibility: false
  },
  {
    icon: <AddRoadOutlined />,
    label: 'Roads',
    id: 1,
    visibility: false
  },
  {
    icon: <HomeWorkOutlined />,
    label: 'Buildings',
    id: 2,
    visibility: false
  },
  {
    icon: <HdOutlined />,
    label: 'HD Ortho Imagery',
    id: 3,
    visibility: true
  },
  {
    icon: <HdOutlined style={{ transform: 'rotate(20deg)' }} />,
    label: 'HD Oblique Imagery',
    id: 6,
    visibility: false

  },
  {
    icon: <FilterHdrOutlined />,
    label: 'Terrain (DEM/DSM)',
    id: 4,
    visibility: false

  },
  {
    icon: <PanoramaPhotosphereOutlined />,
    label: 'Panorama Locations',
    id: 5,
    visibility: false

  }
]

const Layers = () => {
  return (
    <Accordion open heading="Layers" id="layers-accordion">
      {
        TDLAYERS.map(({ icon, label, id, visibility }, index) => (
          <AccordionItem key={index} icon={icon} LayerId={id} defaultvisibility={visibility} label={label} type="layer" />
        ))
      }
    </Accordion>
  )
}

export default Layers;